<template>
  <div id="#app">
    <router-view/>
  </div>
</template>

<script>

export default {}
</script>

<style>
body, #app {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
}
</style>
